export const VISION_CONSTANTS = {
  title: "A Unified Cloud for the Future ",
  desc: "At OneMind, we don’t just build IT solutions—we create an intelligent, connected digital ecosystem where technology operates in perfect harmony. ",
  points: [
    {
      title: "🚀  Our Vision: A Limitless Cloud Ecosystem ",
      desc: [
        {
          text: "Inspired by ancient wisdom and modern innovation, we believe the future of technology lies in seamless integration, intelligent automation, and resilient security. Our approach is driven by: ",
          highlight: [
            "ancient wisdom",
            "modern innovation",
            "seamless integration",
            "intelligent automation",
            "resilient security",
          ],
        },
      ],
      list: [
        {
          label: "Synergy Over Silos",
          text: " Like the mind integrating thoughts to form wisdom, our cloud, security, and automation services unify technology into a frictionless experience.",
        },
        {
          label: "Security Over Fragmentation",
          text: "Inspired by India’s ancient fortresses, we build resilient cloud security frameworks that safeguard businesses against evolving threats.",
        },
        {
          label: "Intelligence Over Chaos ",
          text: "Like the disciplined focus of a yogi, our solutions bring precision, AI-driven insights, and automation to optimize cloud operations effortlessly",
        },
      ],
    },
    {
      title: "🌎  Our Mission: The Power of OneMind in the Cloud",
      desc: [
        {
          text: "OneMind is more than just a company—it’s a movement toward a unified digital future. We bridge the gap between tradition and technology, leveraging cloud-native solutions, automation, and observability to help businesses scale, secure, and thrive. Our mission is to empower organizations with cutting-edge tools and strategies, enabling them to achieve unparalleled agility, efficiency, and resilience in a fast-evolving digital landscape. ",
          highlight: [
            "automation",
            "observability",
            "cloud-native solutions",
            "scale",
            "secure",
            "thrive",
            "tradition",
            "technology",
            "agility",
            "efficiency",
            "resilience",
          ],
        },
        {
          text: "Just as ancient Indian philosophy teaches that the mind shapes reality, we believe that unified intelligence and cloud innovation can shape the future of businesses. ",
          highlight: ["unified intelligence", "cloud innovation"],
        },
      ],
    },
  ],
};
